export const getUser = ({ user }) => user;